module.exports = __webpack_public_path__ + "img/baniere4.e3b731e1.jpg";